<template>
  <span>
    <span class="badge bg-info me-1" v-if="workOrder?.isLeakageTest">Tesnost</span>
    <span class="badge bg-success me-1" v-if="workOrder?.isService">Servis</span>
    <span class="badge bg-danger me-1" v-if="workOrder?.isCondenserCleaning">Kondenzator mokro</span>
    <span class="badge bg-danger text-dark me-1" v-if="workOrder?.isCondenserCleaningDry">Kondenzator suho</span>
    <span class="badge bg-dark me-1" v-if="workOrder?.isGeneratedPeriodic">Generiran</span>
    <span class="badge bg-warning text-dark me-1" v-if="workOrder?.isThermometerCal">Termometri</span>
    <span class="badge bg-primary me-1" v-if="workOrder?.isCo2Check">CO2</span>
    <span class="badge bg-secondary me-1" v-if="workOrder?.isSystemCheck">Sistem</span>
    <span class="badge bg-secondary me-1" v-if="workOrder?.isAlarmTest">Alarm</span>
    <span class="badge bg-secondary me-1" v-if="workOrder?.isLedomatCheck">Ledomat</span>
  </span>
</template>

<script>
// moved out of OrderIsBadge.js verbatim - options API, there is no setup() to lift
export default {
  name: "OrderIsBadge",
  props: {
    workOrder: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
